import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { filter, map } from 'rxjs';
import { AppRouteData, AppRouteDataHeader } from '../../modules/app-route/models/app-route.model';
import { NavInfoService } from '../../modules/nav-info';
import { BreakpointService } from '../../services/breakpoint.service';
import { ApplicationToolbarContentIconGaleWarningComponent } from '../application-toolbar-content-icon-gale-warning/application-toolbar-content-icon-gale-warning.component';
import { ApplicationToolbarContentIconNewsComponent } from '../application-toolbar-content-icon-news/application-toolbar-content-icon-news.component';
import { ApplicationToolbarContentIconWeatherComponent } from '../application-toolbar-content-icon-weather/application-toolbar-content-icon-weather.component';

@Component({
    selector: 'app-application-toolbar-content',
    imports: [
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        ApplicationToolbarContentIconNewsComponent,
        ApplicationToolbarContentIconWeatherComponent,
        ApplicationToolbarContentIconGaleWarningComponent
    ],
    templateUrl: './application-toolbar-content.component.html',
    styleUrl: './application-toolbar-content.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationToolbarContentComponent {
  /**
   * DI
   */
  breakpointService = inject(BreakpointService);
  titleService = inject(Title);
  #router = inject(Router);
  #navInfoService = inject(NavInfoService);



  // DEMO constructor
  // constructor() {
  //   // log this component
  //   console.log('ApplicationToolbarContentComponent instantiated: this', this);
  // }
  /**
   * Signal providing current AppRouteDataHeader settings
   * - if null, the default header is shown
   */
  public headerData: Signal<AppRouteDataHeader | null> = toSignal(this.#router.events.pipe(
    filter(event => (event instanceof NavigationEnd)),
    map(() => {
      /** Get the current route from router state */
      let currentRoute = this.#router.routerState.root;
      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }
      const appRouteData: AppRouteData = currentRoute.routeConfig?.data as AppRouteData;
      return appRouteData?.header ?? null;
    })
  ), { initialValue: null });



  // /**
  //  * Navigate back using browser history
  //  * - This is not a router navigation and is not what we actually want
  //  */
  // public backward() {
  //   this.location.back();
  // }
  /**
   * Method to move up one level in the router tree
   */
  public goUp(): void {
    const currentUrlSegments = this.#router.url.split('/');
    currentUrlSegments.pop();
    const newUrl = (currentUrlSegments.length > 0) ? currentUrlSegments.join('/') : '/';
    this.#router.navigateByUrl(newUrl);
  }

  /**
   * Go to previous route or to the home component
   */
  public backward(): void {
    this.#router.navigateByUrl(this.#navInfoService.previousUrl$.value || '/');
  }
}
